import { render } from "./LadTableConfiguration.vue?vue&type=template&id=6153546a"
import script from "./LadTableConfiguration.vue?vue&type=script&lang=js"
export * from "./LadTableConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "/root/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__